import { inject } from 'vue'
import { tracesViewContextKey, type TracesViewContext } from './traces-view-context'

export default function useTracesViewContext(): TracesViewContext {
  const tracesViewContext = inject(tracesViewContextKey)
  if (!tracesViewContext) {
    throw new Error(
      'Traces view context not found. Ensure this component is used within MonitoringView.',
    )
  }
  return tracesViewContext
}
